import { LdOption } from "@emdgroup-liquid/liquid/dist/react";
import { TableFilterProps } from "@src/types";
import {
  StyledDropdown,
  StyledDropdownButton,
  StyledDropdownWrapper,
} from "./TableFilter.style";

const TableFilter = ({
  label,
  options,
  onSelect,
  width,
  tetherOptions,
  disabled,
  placeholder,
  popperClass,
  filter,
}: TableFilterProps) => {
  const handleChange = (ev: { detail: string[]; stopPropagation: any }) => {
    ev.stopPropagation();
    if (onSelect && typeof onSelect === "function") {
      onSelect(ev.detail);
    }
  };
  return (
    <StyledDropdownWrapper>
      <StyledDropdownButton>{label || "Filter"}</StyledDropdownButton>
      <StyledDropdown
        key={options.length > 0 ? options[0]?.value : ""}
        width={width}
        onLdchange={handleChange}
        tetherOptions={tetherOptions}
        disabled={disabled}
        placeholder={placeholder}
        popperClass={popperClass}
        filter={filter}
        preventDeselection
      >
        {options.map((option, index) => (
          <LdOption
            key={option.value}
            value={option.value}
            selected={option.checked}
            disabled={option.disabled}
          >
            {option.label}
          </LdOption>
        ))}
      </StyledDropdown>
    </StyledDropdownWrapper>
  );
};

export { TableFilter };
